module.exports = __webpack_public_path__ + "static/media/normal.468b8ee9.cur";